"use strict";
import { Controller } from "stimulus";
import QRCode from "qrcode";

export default class extends Controller {
  static targets = [];

  connect() {
    const canvas = this.element;

    QRCode.toCanvas(canvas, this.element.dataset.url, {
      width: 120
    })
      .then(url => {})
      .catch(err => {
        console.error(err);
      });
  }
}
